export default __webpack_public_path__ + "static/media/logo.15b1d9b1.png";